import { useCallback } from 'react';
import { HOTLINE_PRO_DETAIL_INDEX_SCROLL_CONTENT } from '@/feature/hotline/professional/detail/index/page/HotlineProDetailView';
import { HOTLINE_PRO_DETAIL_MEETING_SCROLL_CONTENT } from '@/feature/hotline/professional/detail/meeting/page/HotlineProDetailMeetingView';
import { HOTLINE_PRO_DETAIL_NEGOTIATE_SCROLL_CHAT, HOTLINE_PRO_DETAIL_NEGOTIATE_SCROLL_SCHEDULE, } from '@/feature/hotline/professional/detail/negotiate/page/HotlineProDetailNegotiateView';
import { scrollToWithHeaderHeight } from '@/helpers/ScrollUtils';
import { useLocation } from '@/hooks/lib/react-router/useLocation';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { pagePath } from '@/utils/router/pagePath';
const hotlineProPath = pagePath.hotline.professional;
/**
 * ボタンクリック時の処理を返す hook
 */
export const useHotlineProDetailStepsButton = (options) => {
    const { id } = options;
    const history = useNavigate();
    const { pathname } = useLocation();
    /**
     * 該当箇所まで遷移してスクロールさせる
     * @description 該当ページにいる場合スクーロール、いない場合はハッシュをつけて遷移
     * @param page 表示したいページのパス
     * @param scrollTargetName スクロールさせたい ScrollElement の name
     */
    const scrollToTarget = useCallback((targetPath, scrollTargetName) => {
        // 現在のページと遷移先のページが同じ場合
        if (pathname === targetPath) {
            // スクロール
            scrollToWithHeaderHeight(scrollTargetName);
        }
        else {
            // ページ遷移
            history.push(`${targetPath}#${scrollTargetName}`);
        }
    }, [history, pathname]);
    /**
     * 相談内容を確認ボタンクリック時の処理
     */
    const onClickButtonDetail = useCallback(() => {
        scrollToTarget(hotlineProPath.detail(id), HOTLINE_PRO_DETAIL_INDEX_SCROLL_CONTENT);
    }, [scrollToTarget, id]);
    /**
     * チャットボタンをクリック時の処理
     */
    const onClickButtonNegotiate = useCallback(() => {
        scrollToTarget(hotlineProPath.detailNegotiate(id), HOTLINE_PRO_DETAIL_NEGOTIATE_SCROLL_CHAT);
    }, [scrollToTarget, id]);
    /**
     * 承諾するボタンをクリック時の処理
     */
    const onClickButtonNegotiateSchedule = useCallback(() => {
        scrollToTarget(hotlineProPath.detailNegotiate(id), HOTLINE_PRO_DETAIL_NEGOTIATE_SCROLL_SCHEDULE);
    }, [scrollToTarget, id]);
    /**
     * 相談開始ボタンをクリック時の処理
     */
    const onClickButtonMeeting = useCallback(() => {
        scrollToTarget(hotlineProPath.detailMeeting(id), HOTLINE_PRO_DETAIL_MEETING_SCROLL_CONTENT);
    }, [scrollToTarget, id]);
    return {
        onClickButtonDetail,
        onClickButtonMeeting,
        onClickButtonNegotiate,
        onClickButtonNegotiateSchedule,
    };
};
